const qaRegex = /qa\d+/

/**
 * Get the environment label that corresponds to the CMS environment in use.
 *
 * @param {object} options
 * @property {string} options.serverId (catalina property)
 * @property {boolean} options.isDevelopmentServer (catalina property)
 * @returns {string} environment label
 */
const getEnvironment = ({ serverId, isDevelopmentServer } = {}) => {
  if (!isDevelopmentServer) {
    return 'production'
  }

  if (qaRegex.test(serverId)) {
    return 'qa'
  }

  return 'development'
}

export default getEnvironment



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-js/utils/getEnvironment.js